import React, { useState, useEffect } from "react";
import macauHotel from "../../assets/images/hotel_banner.jpg";
import SubHeaderBanner from "../../components/SubHeaderBanner";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "./style.scss";
const style = {
  noBorder: {
    border: "none",
  },
  root: {
    borderColor: "orange",
  },
};

function Hotel() {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    // window.scrollTo(0, 0);
    // document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });

  const options = [
    {
      label: "Danang Marriott Resort & Spa",
      value: "4,200,000 VND",
    },
    // {
    //     label: "Le Meridien Mina Seyahi",
    //     value: "AED 3‘750",
    // }
  ];

  const dates = [
    "2 Mar, Mon",
    "3 Mar, Tue",
    "4 Mar, Wed",
    "5 Mar, Thu",
    "6 Mar, Fri",
  ];

  // Sample Data: prices per date per room type
  const roomData = [
    {
      type: "Single (1 breakfast)",
      prices: {
        "2 Mar, Mon": "MOP/HKD 1,140 nett",
        "3 Mar, Tue": "MOP/HKD 1,140 nett",
        "4 Mar, Wed": "MOP/HKD 1,140 nett",
        "5 Mar, Thu": "MOP/HKD 1,140 nett",
        "6 Mar, Fri": "MOP/HKD 1,890 nett",
      },
    },
    {
      type: "Double (2 breakfast)",
      prices: {
        "2 Mar, Mon": "MOP/HKD 1,420 nett",
        "3 Mar, Tue": "MOP/HKD 1,420 nett",
        "4 Mar, Wed": "MOP/HKD 1,420 nett",
        "5 Mar, Thu": "MOP/HKD 1,420 nett",
        "6 Mar, Fri": "MOP/HKD 2,160 nett",
      },
    },
  ];

  return (
    <>
      <SubHeaderBanner title="HOTEL" image={macauHotel} />
      <div className="wrapper position-relative">
        <div className="main my-5">
          <section className="section gb nopadtop">
            <div className="container">
              <div className="boxed boxedp4">
                <div className="row">
                  <div className="col-md-12 section-title">
                    <h2 className="text-center font-weight-bold my-5">
                      {" "}
                      Official Conference Hotel: Studio City Macau
                    </h2>
                  </div>
                </div>

                <div className="col-md-12 mb-5">
                  <div className="bg-light my-3">
                    <section className="position-relative pt-3 pt-md-5 pb-3">
                      <div className="container-fluid position-relative">
                        <div className="align-items-sm-center align-items-md-start">
                          <div className="mx-3 mx-md-5 text-justify">
                            <h2 className="font-weight-bold mb-0">
                              Luxury Meets Logistics
                            </h2>
                            <p className="fs-5 w-lg-60 mb-0 mx-auto mt-2">
                              Welcome to Studio City Macau, the official venue
                              partner for the Inaugural ACTnet Members
                              Conference. Strategically located in the heart of
                              Cotai, Studio City offers a seamless blend of
                              modern luxury, world-class facilities, and
                              convenient access — perfect for our global network
                              of logistics leaders.
                            </p>
                          </div>
                          {/* <TableContainer
                            className="mx-3 mx-md-5 mt-5 mt-md-5 table-wrapper"
                            component={Paper}
                          >
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell colSpan={10}>
                                    {" "}
                                    Celebrity King Room (42 sqm)
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>Room Type</TableCell>
                                  {dates.map((date) => (
                                    <TableCell
                                      className="room-header"
                                      key={date}
                                      align="center"
                                      sx={{ border: "1px solid lightgray" }}
                                    >
                                      {date}
                                    </TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {roomData.map((room) => (
                                  <TableRow key={room.type} sx={{ width: 300 }}>
                                    <TableCell
                                      sx={{
                                        padding: "18px",
                                        width: 170,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        whiteSpace: "normal", // allow wrapping
                                        wordBreak: "break-word",
                                        borderBottom: "none",
                                      }}
                                    >
                                      {room.type}
                                    </TableCell>
                                    {dates.map((date) => (
                                      <TableCell
                                        key={date}
                                        align="center"
                                        sx={{ border: "1px solid lightgray" }}
                                      >
                                        {room.prices[date]}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer> */}

                          <div className="container mt-5">
                            <div className="card shadow-sm border-0">
                              <div className="card-body p-4">
                                <h4 className="mb-3">
                                  <span className="text-highlight">
                                    Hotel Accommodation Update
                                  </span>
                                </h4>

                                <p>
                                  Please note that our preferential rate rooms
                                  at <strong>Studio City Hotel</strong> are
                                  <strong> now fully booked.</strong>
                                </p>

                                <p>
                                  For delegates who have not yet secured
                                  accommodation, <br /> we kindly recommend
                                  using external booking platforms to make your
                                  hotel arrangements directly.
                                </p>

                                <div className="table-responsive w-75 mx-auto">
                                  <p className="text-start mb-3">
                                    <strong>
                                      Alternative nearby hotels include:
                                    </strong>
                                  </p>
                                  <table className="table table-bordered align-middle ">
                                    <thead className="table-light">
                                      <tr>
                                        <th scope="col">Hotel</th>
                                        <th scope="col">Distance from Venue</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>
                                          <strong>W Macau – Studio City</strong>
                                        </td>
                                        <td className="text-muted">
                                          Adjacent to the venue
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>The Londoner Macao</strong>
                                        </td>
                                        <td className="text-muted">
                                          Approx. 3 min walk
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>The Parisian Macao</strong>
                                        </td>
                                        <td className="text-muted">
                                          Approx. 5–7 min walk
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>

                                <p>
                                  We encourage you to book early, as
                                  availability may be limited closer to the
                                  event dates.
                                </p>

                                <p className="mb-0">
                                  If you need any support, feel free to contact
                                  our team at{" "}
                                  <a href="mailto:customerservice@fibsglobalconference.com">
                                    customerservice@fibsglobalconference.com
                                  </a>
                                </p>
                              </div>
                            </div>
                          </div>

                          {/* <div className="mx-5 my-4">
                            <p>
                              <small>
                                Charges are subject to change without prior
                                notice
                              </small>
                            </p>
                            <p className="fs-5 w-lg-60">
                              <span className="font-weight-bold">Address:</span>{" "}
                              Estr. Flor de Lótus, Cotai, Macau SAR
                            </p>
                          </div> */}
                        </div>
                      </div>
                    </section>

                    {/* <section className="position-relative overflow-hidden pb-3">
                      <div className="container-fluid position-relative">
                        <div className="row align-items-sm-center align-items-md-start">
                          <div className="col-6 col-sm-3 mb-4 mb-sm-0">
                            <img
                              className="img-fluid rounded-4"
                              alt="..."
                              src={require("../../assets/images/hotel/1.jpg")}
                            ></img>
                          </div>
                          <div className="col-6 col-sm-3 mb-4 mb-sm-0">
                            <img
                              src={require("../../assets/images/hotel/3.jpg")}
                              className="img-fluid rounded-4 mb-3"
                              alt=""
                            />
                          </div>
                          <div className="col-sm-3 col-6">
                            <img
                              src={require("../../assets/images/hotel/4.jpg")}
                              className="img-fluid rounded-4"
                              alt=""
                            />
                          </div>
                          <div className="col-sm-3 col-6">
                            <img
                              src={require("../../assets/images/hotel/5.jpg")}
                              className="img-fluid rounded-4"
                              alt="Presidential Suite"
                            />
                          </div>
                        </div>
                      </div>
                    </section> 

                    <div className="col-12 pb-5" id="pending" align="center">
                      <a
                        href="mailto:customerservice@actnet.co?subject=ACTnet Global Kick-Off Conference 2026 Hotel Booking | Studio City Hotel"
                        className="btn btn-danger"
                      >
                        Book Now{" "}
                      </a>
                    </div>*/}

                    <div className="text-start px-5 pb-5">
                      <h5 className="text-start mt-5">Stay Dates</h5>
                      <p className="text-start">
                        We recommend arriving{" "}
                        <span className="fw-bold">
                          on or before 3 March 2026
                        </span>{" "}
                        and departing{" "}
                        <span className="fw-bold">after 6 March 2026</span> to
                        enjoy the full ACTnet experience.
                      </p>
                      {/* <h5 className="text-start">
                        ACTnet Delegates Special Rates
                      </h5>
                      <p className="text-start mb-2">
                        Exclusive booking links and discount codes will be sent
                        to registered delegates. Book early to secure the best
                        rooms and conference convenience.
                      </p> */}
                      <h5>Getting There</h5>
                      <ul>
                        <li>
                          <span className="fw-bold">By Air:</span> Fly direct to
                          Macau International Airport, with hotel shuttle
                          options available.
                        </li>
                        <li>
                          <span className="fw-bold">Via Hong Kong:</span> Take
                          the{" "}
                          <span className="fw-bold">
                            Hong Kong-Zhuhai-Macau Bridge
                          </span>{" "}
                          or ferry transfer — perfect for combining your trip
                          with a visit to ACTnet’s Hong Kong partners.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="about-us section">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <div
                  className="left-image wow fadeIn text-white"
                  data-wow-duration="1s"
                  data-wow-delay="0.2s"
                >
                  <h2 className="">Why Studio City Macau?</h2>
                </div>
              </div>
              <div className="col-lg-8 align-self-center">
                <div className="services">
                  <div className="row">
                    <div className="col-lg-6">
                      <div
                        className="item wow fadeIn d-flex"
                        data-wow-duration="1s"
                        data-wow-delay="0.5s"
                      >
                        <div className="icon hotel-icon">
                          <img src="assets/images/check.png" alt="" />
                        </div>
                        <div className="right-text text-start">
                          <h4>Prime Location</h4>
                          <p>
                            Nestled between the bustling city and scenic views,
                            Studio City is just minutes from Macau International
                            Airport and ferry terminals.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div
                        className="item wow fadeIn d-flex"
                        data-wow-duration="1s"
                        data-wow-delay="0.7s"
                      >
                        <div className="icon hotel-icon">
                          <img src="assets/images/check.png" alt="" />
                        </div>
                        <div className="right-text text-start">
                          <h4> 5-Star Comfort</h4>
                          <p>
                            Indulge in spacious rooms, on-site dining, wellness
                            amenities, and entertainment all under one roof.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-9">
                      <div
                        className="item wow fadeIn d-flex"
                        data-wow-duration="1s"
                        data-wow-delay="0.9s"
                      >
                        <div className="icon hotel-icon">
                          <img src="assets/images/check.png" alt="" />
                        </div>
                        <div className="right-text text-start">
                          <h4>Networking Ready</h4>
                          <p>
                            Equipped with premium event spaces, fast Wi-Fi, and
                            business lounges — ideal for face-to-face meetings
                            and strategic conversations.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Hotel;
